var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1744 9.55141C2.09992 9.37718 2.06152 9.18965 2.06152 9.00016C2.06152 8.81068 2.09992 8.62315 2.1744 8.44891C2.7804 7.00891 3.7494 5.79766 4.9614 4.96366C6.1734 4.12966 7.5774 3.70891 9.00015 3.75316C10.4229 3.70891 11.8261 4.12966 13.0389 4.96366C14.2516 5.79766 15.2199 7.00891 15.8259 8.44891C15.9004 8.62315 15.9388 8.81068 15.9388 9.00016C15.9388 9.18965 15.9004 9.37718 15.8259 9.55141C15.2199 10.9914 14.2509 12.2027 13.0389 13.0367C11.8269 13.8707 10.4229 14.2914 9.00015 14.2472C7.5774 14.2914 6.17415 13.8707 4.9614 13.0367C3.74865 12.2027 2.7804 10.9914 2.17515 9.55141",
    stroke: "#8E8E8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.625C9.34472 11.625 9.68606 11.5571 10.0045 11.4252C10.323 11.2933 10.6124 11.0999 10.8562 10.8562C11.0999 10.6124 11.2933 10.323 11.4252 10.0045C11.5571 9.68606 11.625 9.34472 11.625 9C11.625 8.65528 11.5571 8.31394 11.4252 7.99546C11.2933 7.67698 11.0999 7.3876 10.8562 7.14384C10.6124 6.90009 10.323 6.70673 10.0045 6.57482C9.68606 6.4429 9.34472 6.375 9 6.375C8.30381 6.375 7.63613 6.65156 7.14384 7.14384C6.65156 7.63613 6.375 8.30381 6.375 9C6.375 9.69619 6.65156 10.3639 7.14384 10.8562C7.63613 11.3484 8.30381 11.625 9 11.625Z",
    stroke: "#8E8E8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/openEye.cbda75b6bcf3ca02e7b9860dad7437f0.svg";
export { ForwardRef as ReactComponent };